export default "__VITE_ASSET__68fb9a22__"